import useButtonClickHandler from '../../../hooks/useButtonClickHandler';
import {twx} from '../../../utils/tailwindUtils';
import ButtonLoader from '../../Loader/ButtonLoader';

const BaseButton = ({
    children,
    onClick,
    route,
    modalType,
    rumActionName,
    isOnlineCheck,
    state,
    isClickTracked,
    ...rest
}) => {
    const onClickHandler = useButtonClickHandler({
        onClick,
        route,
        modalType,
        rumActionName,
        isOnlineCheck,
        state,
        isClickTracked,
    });

    return (
        <button onClick={onClickHandler} {...rest}>
            {children}
        </button>
    );
};

const ButtonTemplate = ({children, disabled, className, isLoading, ...rest}) => (
    <BaseButton
        disabled={disabled || isLoading}
        className={twx(
            'text-base inline-block w-full rounded-full border bg-color-romance py-3 text-center font-normal text-color-primary shadow-sm transition duration-200',
            'hover-pointer-fine:hover:border-color-white-50 hover-pointer-fine:hover:bg-color-tertiary hover-pointer-fine:hover:shadow-md hover-pointer-fine:hover:dark:bg-color-tertiary',
            'active:border-color-white-50 active:bg-color-tertiary active:shadow-sm active:ring-4 active:ring-color-white-50 active:ring-opacity-50',
            'disabled:pointer-events-none disabled:opacity-60',
            className
        )}
        {...rest}
    >
        {isLoading ? <ButtonLoader className='mx-2' /> : children}
    </BaseButton>
);

export const Button = ({className, isLightStyleOnly, ...rest}) => (
    <ButtonTemplate
        className={twx(
            {'dark:bg-color-primary dark:text-color-romance': !isLightStyleOnly},
            {'bg-color-romance text-color-primary': isLightStyleOnly},
            className
        )}
        {...rest}
    />
);

export const LightButton = ({className, isLightStyleOnly, ...rest}) => (
    <ButtonTemplate
        className={twx(
            'bg-color-primary text-color-romance',
            {'dark:bg-color-romance dark:text-color-primary': !isLightStyleOnly},
            className
        )}
        {...rest}
    />
);

export const TransparentButton = ({className, ...rest}) => {
    return (
        <ButtonTemplate
            className={twx(
                'border-[1.5px] border-color-primary bg-transparent text-color-primary',
                'dark:border-color-romance dark:text-color-romance',
                className
            )}
            {...rest}
        />
    );
};

export const UnderlineButton = ({children, className, ...rest}) => (
    <BaseButton
        className={twx(
            'cursor-pointer border-none bg-transparent text-color-primary underline decoration-color-primary transition duration-200 focus:outline-none',
            'dark:text-color-romance dark:decoration-color-romance',
            'hover:decoration-color-tertiary hover:dark:decoration-color-tertiary',
            className
        )}
        {...rest}
    >
        {children}
    </BaseButton>
);

export const UnstyledButton = ({children, className, ...rest}) => (
    <BaseButton className={twx('tracking-wide', className)} {...rest}>
        {children}
    </BaseButton>
);
